import * as THREE from 'three';

export class ObjectPlacer {
    constructor(scene, camera, renderer) {
        this.scene = scene;
        this.camera = camera;
        this.renderer = renderer;
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
        this.placementPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
        
        this.onPlaceCallback = null;
        this.isEnabled = false;
        
        this.init();
    }

    init() {
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    enable(onPlaceCallback) {
        this.isEnabled = true;
        this.onPlaceCallback = onPlaceCallback;
        this.renderer.domElement.addEventListener('click', this.handleClick);
        this.renderer.domElement.addEventListener('mousemove', this.handleMouseMove);
        this.renderer.domElement.style.cursor = 'crosshair';
    }

    disable() {
        this.isEnabled = false;
        this.onPlaceCallback = null;
        this.renderer.domElement.removeEventListener('click', this.handleClick);
        this.renderer.domElement.removeEventListener('mousemove', this.handleMouseMove);
        this.renderer.domElement.style.cursor = 'default';
    }

    handleClick(event) {
        if (!this.isEnabled) return;
        
        const rect = this.renderer.domElement.getBoundingClientRect();
        this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        
        this.raycaster.setFromCamera(this.mouse, this.camera);
        
        // Try to intersect with scene objects first
        const intersects = this.raycaster.intersectObjects(this.scene.children, true);
        
        if (intersects.length > 0) {
            const point = intersects[0].point;
            if (this.onPlaceCallback) {
                this.onPlaceCallback(point);
            }
        } else {
            // If no intersection, place on a default plane at y=0
            const point = new THREE.Vector3();
            this.raycaster.ray.intersectPlane(this.placementPlane, point);
            if (this.onPlaceCallback) {
                this.onPlaceCallback(point);
            }
        }
    }

    handleMouseMove(event) {
        if (!this.isEnabled) return;
        
        // Optional: Show preview indicator
        // Could be implemented to show where object will be placed
    }

    getIntersectionPoint(event) {
        const rect = this.renderer.domElement.getBoundingClientRect();
        this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        
        this.raycaster.setFromCamera(this.mouse, this.camera);
        
        const intersects = this.raycaster.intersectObjects(this.scene.children, true);
        
        if (intersects.length > 0) {
            return intersects[0].point;
        } else {
            const point = new THREE.Vector3();
            this.raycaster.ray.intersectPlane(this.placementPlane, point);
            return point;
        }
    }
}
